// 项目
import { $post, $get,$delete,$patch} from '@/utils/http'
import Service from './Service'
import Storage from '@/utils/storage'

// 接口集合
const _url = {
    // 获取项目列表
    getList: `/ucenter/v2/projects/list`,
    // 获取单个项目信息
    getInfo: `/ucenter/v2/projects/info`,       //  未写
    // 增加项目
    add: '/ucenter/v2/projects',
    // 删除项目
    detele: `/ucenter/v2/projects`,
    // 编辑项目
    edit: `/ucenter/v2/projects`,
    // 增加项目模板
    addTemplate: `/ucenter/v2/projects/addprojecttemp`,
    // 修改项目模板
    editTemplate: `/ucenter/v2/projects/editprojecttemp`,
    // 删除项目模板
    deteleTemplate: `/ucenter/v2/projects/delprojecttemp`,
    // 查询项目模板信息
    getTemplate: `/ucenter/v2/projects/getprojecttemp`,
    // 查询项目模板列表
    getTemplateList: `/ucenter/v2/projects/listprojecttemp`,
}

Service.getProjectList = async function (params) {
    let request = {}
    // 项目名称
    request['project_name'] = params.project_name;
	
    // 省、市、区
    request['province'] = params.province;
    request['city'] = params.city;
    request['dist'] = params.dist;
    // 项目负责人
    request['project_principal_name'] = params.project_principal_name;
    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get(_url.getList, request);
    return Service.handleCommonError(data)
}
Service.getProjectInfo = async function () {
    let request = {}

    // 项目Id
    request['assigned_project_id'] = Service.getProjectId();
    if (!request['assigned_project_id']) return;
    
    // 如果本地有缓存项目信息，直接返回
    if (Storage.get('ProjectInfo')){
        return Storage.get('ProjectInfo').projectInfo;
    }
    let data = await $get(_url.getInfo, request);
    return Service.handleCommonError(data)
}

Service.addProject= async function (params) {
    let request = {}
    // 项目名称
    request['project_name'] = params.project_name;
	// 项目负责人
	request['project_principal_name'] = params.project_principal_name;
	// 项目负责人电话
	request['project_principal_tel'] = params.project_principal_tel;
    // 物业名称
    request['property'] = params.property;
	// 物业负责人
	request['property_principal_name'] = params.property_principal_name;
	// 物业负责人电话
	request['property_tel'] = params.property_tel;
    // 建筑类型
    request['buildings_template_id'] = params.buildings_template_id;
    // 系统类型
    request['sysid'] = params.sysid;
    // // 	经销商/业务员
    // request['salename'] = params.salename;
    // // 电话
    // request['telphone'] = params.telphone;
    // 国家     暂时默认中国
    request['country'] = params.country;
    // 省、市、区
    request['province'] = params.province;
    request['city'] = params.city;
    request['dist'] = params.dist;
    request['longitude'] = params.longitude;
    request['latitude'] = params.latitude;
    // 详细地址
    request['address'] = params.address;
    // 项目logo
    request['icon'] = params.icon;
    // 计费策略
    // request['default_statistic_rule'] = params.default_statistic_rule;
    // 备注
    request['description'] = params.description;

    let data = await $post(_url.add, request);
    return Service.handleCommonError(data)
}

Service.editProject = async function (params) {
    let request = {}
    // 项目ID
    request['oid'] = params.oid;
    // 项目名称
    request['project_name'] = params.project_name;
	// 项目负责人
	request['project_principal_name'] = params.project_principal_name;
	// 项目负责人电话
	request['project_principal_tel'] = params.project_principal_tel;
    // 物业名称
    request['property'] = params.property;
	//物业负责人
	request['property_principal_name'] = params.property_principal_name;
	//物业负责人电话电话
	request['property_tel'] = params.property_tel;
    // 项目logo
    request['icon'] = params.icon;
    // 计费策略 不能修改
    // request['default_statistic_rule'] = params.projectname;
    // 备注
    request['description'] = params.description;

    let data = await $patch(_url.edit, request);
    return Service.handleCommonError(data)
}

Service.deteleProject = async function (params) {
    let request = {}
	var formData = new FormData();
	formData.append("oid", params.oid);
    let data = await $delete(_url.detele, formData);
    return Service.handleCommonError(data)
}

Service.addTemplate = async function (params) {
    let request = {}
    // 项目模板名称
    request['typename'] = params.typename;
    // 模板JSON
    request['description'] = JSON.stringify(params.description);
    
    let data = await $post(_url.addTemplate, request);
    return Service.handleCommonError(data)
}

Service.editTemplate = async function (params) {
    let request = {}
    // 项目模板OID
    request['oid'] = params.oid;
    // 项目模板名称
    request['typename'] = params.typename;
    // 模板JSON
    request['description'] = JSON.stringify(params.description)

    let data = await $post(_url.editTemplate, request);
    return Service.handleCommonError(data)
}

Service.deteleTemplate = async function (params) {
    let request = {}
    // 项目模板OID
    request['oid'] = params.oid;

    let data = await $post(_url.deteleTemplate, request);
    return Service.handleCommonError(data)
}

Service.getTemplate = async function (params) {
    let request = {}
    // 项目模板OID
    request['oid'] = params.oid;
    
    let data = await $get(_url.getTemplate, request);
    return Service.handleCommonError(data)
}

Service.getTemplateList = async function () {
    let request = {}
    // 	第几页
    request['page_num'] = 1;
    // 	一页几条数据
    request['page_sum'] = 100;
    let data = await $get(_url.getTemplateList, request);
    // 处理列表为空
    let res = Service.handleCommonError(data);
    return res === 'success' ? [] : res
}